<template>
  <div>
    <!-- <breadcrumb v-bind:path2="path2"></breadcrumb> -->
    <div class="returns">
      <div class="main-content">
        <h2 v-if="$i18n.locale == 'en'">DELIVERY POLICY</h2>
        <h2 v-if="$i18n.locale == 'ch'">送貨</h2>

        <div v-if="$i18n.locale == 'en'">
          <section>
            <h4>When can you schedule a delivery?</h4>
            <hr>

            <p>You can place an order anytime at your convenience. However, the delivery hour cannot be scheduled. We will deliver it to you the same day by 7PM if you placed your order before 12PM and the following day by 7PM if you placed your order after 12PM.</p>
          </section>
          <section>
          <h4>Do I need to be available for receiving my order?</h4>
          <hr>

          <p>No, we will drop off your order at the door. You will get an email and text message when it has been delivered.</p></section>

          <section>
          <h4>How much do I tip?</h4>
          <hr>

          <p>You do not need to tip the shoppers.</p></section>

          <section>
          <h4>Where is my receipt?</h4>
          <hr>

          <p>You will receive an email confirmation with a digital receipt once your order is delivered.</p></section>

          <section>
          <h4>Will AFM deliver groceries to a business location?</h4>
          <hr>

          <p>Yes, as long as the location is in our coverage area.</p></section>

          <section>
          <h4>Do you use personal cars or AFM vehicles?</h4>
          <hr>

          <p>We use AFM vehicles. You will find our logo on the car as well.</p></section>

          <section>
          <h4>After my order was delivered, I found out that I was missing item(s) from my order. What should I do?</h4>
          <hr>

          <p>You can contact our support team via live chat on our webpage, email us at admin@shopafm.com, or call us at (425)357-2992. Please note that there is a 7 day limitation for reporting issues on an order.</p></section>

          <section>
          <h4>There are damaged item(s) in my order. What should I do?</h4>
          <hr>

          <p>You can contact our support team via live chat on our webpage, email us at admin@shopafm.com, or call us at (425)357-2992. Please note that there is a 7 day limitation for reporting issues on an order.</p></section>
        </div>
        <div v-if="$i18n.locale == 'ch'">
          <section>
          <h4>我可以選擇送貨的具體時間嗎？</h4>

          <p>您可以在任意時間下訂單。 但是，送貨具體時間無法安排。 如果您在12PM之前下訂單，我們將在當天晚上7點之前將其交付給您；如果您在12 PM之後下訂單，則將在第二天7pm之前將其交付給您。</p></section>

          <section>
          <h4>我需要隨時在家等待我的訂單送到嗎？</h4>

          <p>不，我們會把您的貨物放在您家門口。交付後，您將收到一封電子郵件和文本消息。</p></section>

          <section>
          <h4>我要給多少小費？</h4>

          <p>您不需要給送貨員消費</p></section>

          <section>
          <h4>我的收據在哪裡？</h4>

          <p>訂單交付後，您將收到一封電子收據的電子郵件確認。</p></section>

          <section>
          <h4>AFM可以將雜貨運送到公司地址嗎？</h4>

          <p>是的，只要您的地址在我們的送貨覆蓋範圍內即可。</p></section>

          <section>
          <h4>AFM使用的是私人車輛還是AFM專用車輛？</h4>

          <p>我們使用AFM專用車輛。您還將在車上找到我們的商標。</p></section>

          <section>
          <h4>訂單交付後，我發現我的訂單中少物品了。 我該怎麼辦？</h4>

          <p>您可以在我們的網頁上通過實時聊天與我們的支持團隊聯繫，通過admin@shopafm.com向我們發送電子郵件，或通過(425)357-2992與我們聯繫。 請注意，報告訂單問題有7天的限制。</p></section>

          <section>
          <h4>我的訂單中有損壞的物品。 我該怎麼辦？</h4>

          <p>您可以在我們的網頁上通過實時聊天與我們的支持團隊聯繫，通過admin@shopafm.com向我們發送電子郵件，或通過(425)357-2992與我們聯繫。 請注意，報告訂單問題有7天的限制。</p></section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "delivery-policy",
  components: {

  },
  data() {
    return {
      path2: 'Delivery Policy',
    }
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/returns.less";
</style>



// WEBPACK FOOTER //
// src/view/deliveryPolicy.vue